import { NgModule } from "@angular/core";
import { EnableC3C5WorkflowComponent } from "./enable-c3-c5-workflow.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DialogModule } from "src/app/shared/components/dialog/dialog.module";
import { CheckboxModule } from "src/app/shared/components/checkbox/checkbox.module";
import { OptionsListModule } from "src/app/shared/components/options-list/options-list.module";

@NgModule({
    declarations: [
     EnableC3C5WorkflowComponent,

    ],
    exports: [
        EnableC3C5WorkflowComponent,
    ],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      DialogModule,
      OptionsListModule,
      CheckboxModule,
    ],
  })
  export class EnableC3C5WorkflowModule {
  }